import { render, staticRenderFns } from "./MarcaActivoDialogComponent.vue?vue&type=template&id=5d9c0256"
import script from "./MarcaActivoDialogComponent.vue?vue&type=script&lang=js"
export * from "./MarcaActivoDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports